import { computed, defineComponent, onMounted, reactive, h } from '@vue/composition-api';
import { withInstall } from '../util/index';
import "../style/components/autoscale-text.css";
var AutoscaleText = defineComponent({
  name: 'm-autoscale-text',
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        refs = _ref.refs;
    var widthInfo = reactive({
      boxWidth: 0,
      altWidth: 0
    });

    var reComputeWidthInfo = function reComputeWidthInfo() {
      var _refs$alt;

      widthInfo.altWidth = ((_refs$alt = refs.alt) === null || _refs$alt === void 0 ? void 0 : _refs$alt.clientWidth) || 0;

      if (!widthInfo.boxWidth) {
        var _refs$box;

        widthInfo.boxWidth = ((_refs$box = refs.box) === null || _refs$box === void 0 ? void 0 : _refs$box.clientWidth) || 0;
      }
    };

    var altStyle = computed(function () {
      if (!widthInfo.boxWidth || !widthInfo.altWidth) return;
      var innerWidth = widthInfo.boxWidth;
      if (innerWidth >= widthInfo.altWidth) return;
      return {
        transform: "scale(".concat(innerWidth / widthInfo.altWidth, ")")
      };
    });
    onMounted(reComputeWidthInfo);
    return function () {
      var _slots$default;

      return h("div", {
        "class": "m-autoscale-text-box"
      }, [h("i", {
        "ref": "box",
        "class": "placeholder"
      }), h("div", {
        "class": "alt",
        "style": altStyle.value
      }, [h("i", {
        "ref": "alt",
        "class": "placeholder"
      }), (_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots)])]);
    };
  }
});
withInstall(AutoscaleText);
export default AutoscaleText;